import type { TaskTimeAsignedTo } from '@/types/capacityTracker';
import { apiService } from './api';
import { socketService } from './socketService';

class VacationsService
{
  static async GetAllAsignedTo(request: {
    Teams: string;
    GetTeamId: boolean;
    GetDepartmentId: boolean;
    GetPositionId?: boolean;
    GetAllPeople: boolean;
    GetAllInfo?: boolean;
  }): Promise<TaskTimeAsignedTo[]>
  {
    try
    {
      const response = await apiService.get<TaskTimeAsignedTo[]>(
        `TaskTimeTracking/GetAllAsigned?teams=${request.Teams}&getTeamId=${request.GetTeamId}&getDepartmentId=${request.GetDepartmentId}&getPositionId=${request.GetPositionId ? 'true' : 'false'}&getAllPeople=${request.GetAllPeople}&GetAllInfo=${request.GetAllInfo ? 'true' : 'false'}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetPersonDetails(personId: string): Promise<TaskTimeAsignedTo[]>
  {
    try
    {
      const response = await apiService.get<TaskTimeAsignedTo[]>(
        `Person/GetPersonById?personId=${personId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async CreateVacationsRequest(param: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`VacationsRequest/Add`, {
        ...param,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetVacationRequestByIds(param: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(
        `VacationsRequest/GetVacationRequestByPersonIds`,
        param,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async DeleteVacationRequest(param: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`VacationsRequest/DeleteVacationRequest`, {
        ...param,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async UpdateSwitchRequest(param: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`VacationsRequest/UpdateSwitchRequest`, {
        ...param,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetRequestToleranceDays(): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(`VacationsRequest/GetRequestToleranceDays`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetHolidays(): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(`VacationsRequest/GetHolidays`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetHireDate(param: any): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(`VacationsRequest/GetHireDate?personId=${param}`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /* Vacation Approval */

  static async getAllAsignedToApproval(): Promise<TaskTimeAsignedTo[]>
  {
    try
    {
      const response = await apiService.get<TaskTimeAsignedTo[]>(
        `TaskTimeTracking/GetAllAsigned?teams=`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async UpdateVacationRequest(newModelRequest: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`VacationsRequest/UpdateVacationRequest`, {
        ...newModelRequest,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /* PTOPermissions */

  static async GetPTOPermissions(): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(`PTOPermissions/GetPTOPermissions`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async UpdatePTOPermissions(permissionsVM: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(
        `PTOPermissions/UpdatePTOPermissions`,
        permissionsVM,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /* PTOReport */

  static async GetAllTeams(): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`TaskTimeTracking/GetAll`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllDepartments(): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`TaskTimeTracking/GetAllDepartments`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllProject(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`Project/GetSideMenuProjects`, request);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetFilteredResults(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`VacationsRequest/GetFilteredResults`, request);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetPTOFilterOptions(): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(`VacationsRequest/GetPTOFilterOptions`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }
}

export default VacationsService;
